export default __webpack_public_path__ + "eb79edc58be988e3d0232de07af767e9.png";